module.exports = __webpack_public_path__ + "img/minigoldenmixoverviewleft.e34bb295.jpg";